"use client";

import { FC, PropsWithChildren, useCallback, useContext } from "react";
import { BrowserStorageContext, BrowserStorageIdsEnum } from "@finbackoffice/site-core";

type IStoragePopupBanners = {
    [key: string]: { id: number; last_seen_timestamp: number };
};
import { PopupBanners } from "components/popup-banners/PopupBanners";
import ErrorBoundary from "components/base/error-boundary/ErrorBoundary";
import { IPopupResponse } from "@finbackoffice/clientbff-client";

const DAY_IN_MS = 24 * 60 * 60 * 1000;

export const Page: FC<
    {
        popupBanners?: IPopupResponse[];
    } & PropsWithChildren
> = ({ children, popupBanners }) => {
    const { get, set } = useContext(BrowserStorageContext);

    const handlePopupClose = useCallback(
        (ids: number[]) => {
            const storagePopupBanners: IStoragePopupBanners =
                get(BrowserStorageIdsEnum.POPUP_BANNERS) ?? {};

            Object.values(storagePopupBanners).forEach((item) => {
                if (Date.now() - item.last_seen_timestamp > 30 * DAY_IN_MS) {
                    delete storagePopupBanners[item.id];
                }
            });

            ids.forEach((id) => {
                storagePopupBanners[id] = {
                    id,
                    last_seen_timestamp: Date.now(),
                };
            });

            set(BrowserStorageIdsEnum.POPUP_BANNERS, JSON.stringify(storagePopupBanners));
        },
        [get, set],
    );

    return (
        <>
            {children}
            {popupBanners && popupBanners.length > 0 && (
                <ErrorBoundary name={PopupBanners.name}>
                    <PopupBanners banners={popupBanners} onClose={handlePopupClose} />
                </ErrorBoundary>
            )}
        </>
    );
};
